<template>
  <section>
    <h2 class="h2Title">{{board.boardName}} 게시물 등록</h2>
    <div class="formInfo">
      <v-form ref="formArticle">
      <dl class="infoCont">

        <dt class="formInfoTxt">제목 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="2" v-if="board.boardCategories && board.boardCategories.length > 0">
            <v-select :items="board.boardCategories" item-value="categoryId" item-text="categoryName" v-model="article.categoryId"
                      dense clearable outlined flat label="카테고리" :rules="[rules.required]"/>
          </v-col>
          <v-col class="mgr" sm="6" style="max-width: 65%">
            <v-text-field v-model="article.title" :rules="[rules.required]" label="제목" dense outlined flat clearable maxlength="40"/>
          </v-col>
        </dd>

        <dt class="formInfoTxt" v-if="board.boardType === 'TYPE_SCHEDULE'"> 일정</dt>
        <dd class="formInfoArea" v-if="board.boardType === 'TYPE_SCHEDULE'">
          <date-range-component v-on:event="result => schedulePeriod = result" label="일정 시작일 ~ 종료일"
                                :value="schedulePeriod" :rules="[rules.required, rules.length12]"></date-range-component>
        </dd>

      </dl>
      <dl class="infoCont">

        <dt class="formInfoTxt">작성자 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="2">
            <v-text-field v-model="article.writer" label="작성자명" :rules="[rules.required]" dense outlined flat/>
          </v-col>
          <v-col class="mgr" sm="2">
            <v-text-field v-model="createdAt" label="작성일" :rules="[rules.iso8601]" placeholder="YYYY-MM-DD" dense outlined flat/>
          </v-col>
        </dd>

        <dt class="formInfoTxt" v-if="board.hasNotice">공지 설정 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
        <dd class="formInfoArea" v-if="board.hasNotice">
            <v-switch
                v-model="article.notice"
                flat
                color="amber"
                class="custom-red"
                :label="article.notice ? '공지사항' : '일반게시물'"
                v-if="board.hasNotice"
            ></v-switch>
            <v-spacer style="max-width: 10px"/>
            <v-switch
                v-if="article.notice && board.hasPeriod"
                v-model="article.always"
                flat
                color="primary"
                :label="article.always ? '상시노출' : '기간제한'"
            ></v-switch>
            <v-spacer style="max-width: 10px" />
            <date-range-component v-if="!article.always && article.notice" v-on:event="searchDate => period = searchDate" label="공지 시작일 ~ 종료일"
                                  :value="period" :rules="[rules.required, rules.length12]"></date-range-component>
        </dd>

      </dl>

      <dl class="infoCont" v-if="article.articleAttachments && article.articleId && board.boardType === 'TYPE_PHOTO'">
        <dt class="formInfoTxt">대표이미지 설정</dt>
        <dd style="padding-left: 5px" >
          <v-row>
            <div
                v-for="img in article.articleAttachments.filter(a => a.contentType.indexOf('image') === 0)"
                :key="img.fileId"
                style="padding: 30px 5px 30px 5px;"
            >
              <v-card
                  class="mx-auto"
                  style="cursor: pointer; overflow: hidden"
                  max-width="100"
                  max-height="100"
                  @click="setMainImage(img.fileId)"
              >
                <v-icon color="yellow" v-if="img.mainImage" style="color: yellow; position: absolute">mdi-image-album</v-icon>
                <img :src="`/attachment/${img.fileContextPath}${img.fileServerName}`" />
              </v-card>
<!--              <v-img-->
<!--                  :src="`/attachment/${img.fileContextPath}${img.thumbnail}`"-->
<!--                  :lazy-src="`${img.fileContextPath}${img.thumbnail}`"-->
<!--                  aspect-ratio="1"-->
<!--                  max-height="100"-->
<!--                  max-width="100"-->
<!--                  class="grey lighten-2"-->
<!--                  style="cursor: pointer"-->
<!--                  v-if="img.contentType.indexOf('image') === 0"-->
<!--                  @click="setMainImage(img.fileId)"-->
<!--              >-->
<!--                <v-icon color="yellow" v-if="img.mainImage" style="position: absolute">mdi-image-album</v-icon>-->
<!--                <img :src="`/attachment/${img.fileContextPath}${img.fileServerName}`"/>-->
<!--              </v-img>-->
            </div>
          </v-row>
        </dd>
      </dl>

      <dl class="infoCont">
        <dt class="formInfoTxt">내용</dt>
        <dd style="width:84%;">
            <editor-quill :val="article.contents" ref="contents"/>
<!--          <v-col class="mgr">-->
<!--            <editor-quill :val="article.contents" ref="contents"/>-->
<!--            <editor-tiptap :val="article.contents" ref="contents"/>-->
<!--            <editor-component-->
<!--                ref="contents"-->
<!--                :val="article.contents"-->
<!--                :uploaded="fileMeta"-->
<!--                @callback-upload="uploadImage"-->
<!--                label="게시판 내용" />-->
<!--          </v-col>-->
        </dd>
      </dl>

      <dl class="infoCont" v-if="$route.params.id === '567'">

        <dt class="formInfoTxt">계좌정보</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" sm="3">
            <v-text-field v-model="article.bank" label="은행명" dense outlined flat/>
          </v-col>
          <v-col class="mgr" sm="3">
            <v-text-field v-model="article.accountHolder" label="계좌주" dense outlined flat/>
          </v-col>
          <v-col class="mgr" sm="3">
            <v-text-field v-model="article.accountNumber" label="계좌번호" dense outlined flat/>
          </v-col>
        </dd>

      </dl>
      <dl class="infoCont" v-if="$route.params.id === '567'">

        <dt class="formInfoTxt">회원정보</dt>
        <dd class="formInfoArea">
          <!-- 2022-03-16 add -->
          <div class="mem-search-box">
            <div class="target-user-box" :class="targetUsrBoxClass" ref="targetUserBox" >
              <span ref="targetUserName" class=""> <em v-if="article.targetUser">{{article.targetUser.name}}</em> 
              </span>   
              <button type="button" aria-label="clear icon" class="v-icon notranslate v-icon--link mdi mdi-close theme--light" @click="deleteTargetUser"></button> 
            </div>
            <v-btn class="vBtn" color="#1991eb" dark @click="onClickUser()"> 
              회원정보검색
            </v-btn> 
          </div>
          <!-- 2022-03-16 add -->
        </dd>

      </dl>
      <dl class="infoCont">
        <dt class="formInfoTxt"> 파일 첨부</dt>
        <dd class="formInfoArea">
          <v-col class="mgr" v-if="board.hasAttachment">
            <v-file-input
                v-model="files"
                label="다중 파일 선택"
                multiple
                prepend-icon="mdi-paperclip"
                @change="appendFile"
                @click:clear="clearAllFile"
            >
              <template v-slot:selection="{ text, file }">
                <v-chip
                    small
                    label
                    color="primary"
                    close @click:close="removeFile(file)"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>

            <div v-if="article.articleAttachments && article.articleId">
              <h4>첨부 완료 파일</h4>

                <v-chip v-for="f in attachedFiles" v-bind:key="f.fileId" class="ma-2" close @click:close="removeAttachedFile(f)">
                  <v-tooltip bottom v-if="f.contentType.indexOf('image') === 0">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon>mdi-image</v-icon>
                        {{ f.fileRealName }}
                      </span>
                    </template>

                    <span>
                      <v-img :src="`/attachment/${f.fileContextPath}${f.thumbnail}`" max-height="200" max-width="200"/>
                    </span>
                  </v-tooltip>
                  <span v-else>{{ f.fileRealName }}</span>
                </v-chip>

              <div class="btnStyleBx">
                <div class="btnCommon justify-center">
                  <v-btn class="vBtn" color="gray" dark @click="deleteAttachedFiles">
                    <v-icon left>mdi mdi-delete</v-icon>
                    첨부 완료 파일 전체 삭제
                  </v-btn>

                  <v-btn class="vBtn" color="#fafafa" @click="resetAttachedFiles">
                    <v-icon left>mdi mdi-reload</v-icon>
                    취소
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>
        </dd>


<!--        <dt class="formInfoTxt" v-if="board.boardType === 'TYPE_PHOTO'"> 대표 이미지</dt>-->
<!--        <dd class="formInfoArea" v-if="board.boardType === 'TYPE_PHOTO'">-->
<!--          <v-col class="mgr" sm="2">-->
<!--            <vue-dropzone-->
<!--                ref="articleThumbnailDropzone"-->
<!--                id="dropzone"-->
<!--                :options="dropzoneOptions"-->
<!--                :useCustomSlot="true"-->
<!--                @vdropzone-success="thumbnailSuccess"-->
<!--                @vdropzone-removed-file="thumbnailRemove"-->

<!--            >-->
<!--                <div v-if="article.thumbnail">-->
<!--                  <v-badge-->
<!--                      bordered-->
<!--                      dark-->
<!--                      color="black"-->
<!--                      icon="mdi-delete"-->
<!--                      overlap-->
<!--                      @click.native="thumbnailRemove"-->
<!--                  >-->
<!--                    <img :src="`${endPoint}/board/${board.boardId}/article/${article.thumbnail}`" />-->
<!--                  </v-badge>-->
<!--                </div>-->
<!--                <div class="dropzone-custom-content" v-else>-->
<!--                  <h3 class="dropzone-custom-title">대표 이미지</h3>-->
<!--                  <div class="subtitle">Drag and drop or click to select a file from your computer</div>-->
<!--                </div>-->
<!--            </vue-dropzone>-->
<!--          </v-col>-->
<!--        </dd>-->


      </dl>

      </v-form>
    </div>
    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn class="vBtn" color="#1991eb" dark @click="save">
          <v-icon left>mdi mdi-content-save</v-icon>
          저장
        </v-btn>
        <v-btn class="vBtn" color="#fafafa" @click="goList()">
          <v-icon left>mdi mdi-format-list-bulleted</v-icon>
          목록
        </v-btn>
      </div>
    </div>

    <CommonPopup v-if="memberPopupOpen" :tap="popupTab" @click:targetUserSelect="targetUserInfo" @click:bgDimClose="popupMemberList" ></CommonPopup>
    <loading-overlay
      :active="isLoading"
    />
  </section>
</template>

<script>
import articleApi from '@/api/ArticleApi'
import boardApi from '@/api/BoardApi'

// import EditorComponent from "../component/EditorComponent";
// import EditorTiptap from "@/views/component/EditorTiptapComponent";
import EditorQuill from "@/views/component/EditorQuillComponent";

import DateRageComponent from "@/views/component/DateRageComponent";

import CommonPopup from "@/views/include/common_popoup";

import _ from 'lodash';
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: "ArticleForm",
  components: {
    // 'editor-component': EditorComponent,
    // EditorTiptap,
    EditorQuill,
    'date-range-component': DateRageComponent,
    // vueDropzone: vue2Dropzone
    CommonPopup,
  },
  props: {
    id: String
  }, 
  data: () => ({
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      length12: value => value && value.length > 12 || '필수 입력 항목입니다.',
      iso8601: value => (!value || !!/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/.test(value)) || '날짜 형식이 아닙니다.'
    },
    board:{},
    article: {
      title: null,
      contents: null,
      writer: null,
      always: true,
      customDate: null
    },
    period:[],
    schedulePeriod:[],
    imageFileUrl: null,
    endPoint:process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    fileMeta:{},
    files:[],
    selectedFiles:[],
    attachedFiles:[],
    memberPopupOpen: false,
    popupTab: 'memberlist',
    targetUsrBoxClass : 'off',
    isLoading: false,
  }),
  computed: {
    dropzoneOptions() {
      return {
        url: '',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        maxFiles:2,
        acceptedFileTypes: "image/*",
        headers: {
          'Authorization': `bearer ${this?.$store?.getters?.token ?? ''}`
        },
        uploadMultiple: false,
        clickable: true,
        addRemoveLinks: true
      }
    },
    createdAt: {
      get() {
        return this.article.createdAt ? this.article.createdAt.substr(0, 10) : this.$moment().format("YYYY-MM-DD");
      },
      set(value) {
        this.article.createdAt = value ? value + "T00:00:00" : this.article.createdAt;
      }
    }
  },
  methods: {
    setMainImage(fileId) {
      this.article.mainImageId = fileId;
      this.article.articleAttachments.forEach(a => a.mainImage = false);
      this.article.articleAttachments.filter(a => a.fileId === fileId)[0].mainImage = true;
      // img.mainImage = !img.mainImage
    },
    thumbnailSuccess(file, response) {
      this.article.thumbnail = response.saveName;
      const acceptedFiles = this.$refs.articleThumbnailDropzone.getAcceptedFiles();
      if(acceptedFiles && acceptedFiles.length > 1)
        this.$refs.articleThumbnailDropzone.removeFile(acceptedFiles[0]);
    },
    thumbnailRemove() {
      this.article.thumbnail = null;
    },
    appendFile() {
      this.files = [...new Set([
        ...this.selectedFiles,
        ...this.files
      ])]
      this.selectedFiles = _.cloneDeep(this.files);
    },
    clearAllFile() {
      this.files = [];
      this.selectedFiles = [];
    },
    removeFile(removeFile) {
      this.files = this.files.filter(f => f !== removeFile);
      this.selectedFiles = _.cloneDeep(this.files);
    },
    removeAttachedFile(attachedFile) {
      this.attachedFiles = this.attachedFiles.filter(f => f.fileId !== attachedFile.fileId);
    },
    resetAttachedFiles() {
      this.attachedFiles = this.article.articleAttachments;
    },
    deleteAttachedFiles() {
      this.attachedFiles = []
    },
    uploadImage(f) {
      articleApi.uploadImage(this.$route.params.id, f).then(res => {
        // console.log(res);
        this.fileMeta = res;
      });
    },
    goList() {
      this.$router.push({path: `/board/${this.$route.params.id}/articles`})
    },
    /* 회원 검색 팝업 */
    onClickUser(){ 
      this.popupMemberList(true)
    }, 
    popupMemberList(e) {
      this.memberPopupOpen = e 
      this.$emit('click:bgDim', this.memberPopupOpen)
    },
    targetUserInfo(targetUserInfo) {
      this.targetUser = targetUserInfo; 
      this.$refs.targetUserBox.className = "target-user-box";
      this.$refs.targetUserName.innerText = targetUserInfo.name;
    },
    deleteTargetUser(){
      this.targetUser = null;
      this.$refs.targetUserName.innerText = "";
      this.$refs.targetUserBox.className = "target-user-box off";
    }, 
    async save() {

      if(!await this.$refs.formArticle.validate())
        return;

      this.article.boardId = this.board.boardId;
      this.article.contents = this.$refs.contents.getValue();

      // console.log(this.period);
      this.article.startDt = this.period?.[0]??null;
      this.article.endDt = this.period?.[1]??null;

      this.article.scheduleStartDt = this.schedulePeriod?.[0]??null;
      this.article.scheduleEndDt = this.schedulePeriod?.[1]??null;

      /* 회원정보 저장 추가 */
      if(this.targetUser){
        this.article.targetUser = this.targetUser;
        this.article.targetUser.userHasRoles =(this.targetUser?.userHasRoles??[]).map(x=>x.id.roleId);
        this.article.targetUser.userHasGroups = (this.targetUser?.userHasGroups??[]).map(r=>r.id.groupId);

      }else{
        this.article.targetUser =null;
      }

      // this.article.createdAt = this.article.customDate ? this.article.customDate + "T00:00:00" : this.article.createdAt;
      this.article.articleAttachments = this.attachedFiles;
      this.isLoading = true;
      articleApi.save(this.article, this.files).then(data => {
        if (data) {
          if(this.article.articleId) {
            alert("수정되었습니다.");
          } else {
            alert("등록되었습니다.");
          }
          this.goList();
        } else {
          alert("Error");
        }
      }).finally(() => {
        this.isLoading = false;
      });
    }

  },
  created() {
    if(this.$route.params.articleId) {
      articleApi.get(this.$route.params.id, this.$route.params.articleId).then(data => {

        // console.log(data);
        this.article = data;

        // this.article.customDate = this.article.createdAt.substr(0,10);

        this.attachedFiles = _.cloneDeep(data.articleAttachments);

        this.period = [this.article.startDt, this.article.endDt].filter(d => d !== null);
        this.schedulePeriod = [this.article.scheduleStartDt, this.article.scheduleEndDt].filter(d => d !== null);
        if(data.targetUser === null){
          this.targetUsrBoxClass = "off";
        }else{
          this.targetUsrBoxClass = "";
        } 
      });
    }
    this.article.writer = this.$store.state?.user?.username??'';  

    boardApi.get(this.$route.params.id).then(data => {
      this.board = data;
      this.dropzoneOptions.url = `${process.env.VUE_APP_BASE_API}/board/${this.$route.params.id}/article/upload/image`;
    });

  }
}
</script>

<style lang="scss">
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.formInfo {
  @include form-info;
}

.userDd {
  padding: 10px 0;
}

.list {
  overflow: hidden;
}

.custom-red .v-input--selection-controls__input div {
  color: #6e6e6e;
  //caret-color: #ffc107 !important;
}
.theme--light.v-input--switch .v-input--switch__track {
  //color: rgba(0, 0, 0, 0.38);
  color: #6e6e6e;
}
.theme--light.v-input--switch .v-input--switch__thumb {
  color: #6e6e6e;
}
</style>